import { useMemo, useState } from 'react';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeader from '@/components/feature/SectionHeader';
import { movies } from '@/mocks/movies';
import { getLatestMovies } from '@/utils/content';

const tabs = ['全部', '电影', '电视剧'];

export default function LatestMovies() {
  const [tab, setTab] = useState('全部');

  const list = useMemo(() => {
    const pool = tab === '全部' ? movies : movies.filter((item) => item.type === tab);
    return getLatestMovies(pool, 10);
  }, [tab]);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-portal px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeader
            eyebrow="最新上线"
            title="最新影视推荐"
            description="近期上线的电影与剧集，按年份与热度为你精选排序。"
          />
          <div className="mb-6 flex w-fit items-center gap-1 rounded-full border border-background-200 bg-background-100 px-1 py-1">
            {tabs.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setTab(item)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  tab === item ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
            {list.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-foreground-400">
              <i className="ri-movie-2-line text-2xl" />
            </span>
            <p className="mt-3 text-sm text-foreground-500">暂无最新推荐，敬请期待</p>
          </div>
        )}
      </div>
    </section>
  );
}